import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import PeopleOutlineIcon   from "@mui/icons-material/PeopleOutline";
import ArrowForwardIcon    from "@mui/icons-material/ArrowForward";
import { useContentSetting } from "../../Hooks/ContentSetting";

const NAV_CARDS = [
  {
    id:          "flight-schools",
    title:       "Flight Schools",
    description: "Manage schools, students, staff and billing",
    path:        "/flight-schools",
    icon:        SchoolOutlinedIcon,
  },
  {
    id:          "members",
    title:       "Members",
    description: "View and manage platform members",
    path:        "/members",
    icon:        PeopleOutlineIcon,
  },
];

export default function Dashboard() {
  const navigate = useNavigate();
  const { userInfo } = useContentSetting();

  const greeting = () => {
    const h = new Date().getHours();
    if (h < 12) return "Good morning";
    if (h < 18) return "Good afternoon";
    return "Good evening";
  };

  const name = userInfo?.first_name || userInfo?.firstName || userInfo?.name || "";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#FAF7F2",
        padding: { xs: "28px 16px", sm: "40px 36px" },
        fontFamily: "'Rubik', sans-serif",
      }}
    >
      {/* Header */}
      <Box sx={{ mb: 5 }}>
        <Typography
          sx={{
            fontSize: { xs: "22px", sm: "26px" },
            fontWeight: 600,
            color: "#1a1a1a",
            fontFamily: "'Rubik', sans-serif",
            letterSpacing: "-0.3px",
          }}
        >
          {greeting()}{name ? `, ${name}` : ""}.
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            color: "#aaa",
            fontFamily: "'Rubik', sans-serif",
            mt: 0.5,
          }}
        >
          What would you like to manage today?
        </Typography>
      </Box>

      {/* Cards */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
          gap: "16px",
          maxWidth: 640,
        }}
      >
        {NAV_CARDS.map(({ id, title, description, path, icon: Icon }) => (
          <Box
            key={id}
            onClick={() => navigate(path)}
            sx={{
              backgroundColor: "#ffffff",
              border: "1px solid rgba(26,26,26,0.09)",
              borderRadius: "14px",
              padding: "28px 24px",
              cursor: "pointer",
              transition: "all 0.15s ease",
              boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              "&:hover": {
                borderColor: "#c01e2e",
                boxShadow: "0 4px 16px rgba(192,30,46,0.1)",
                transform: "translateY(-2px)",
              },
            }}
          >
            {/* Icon */}
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: "10px",
                backgroundColor: "rgba(192,30,46,0.07)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#c01e2e",
              }}
            >
              <Icon sx={{ fontSize: 22 }} />
            </Box>

            {/* Text */}
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#1a1a1a",
                  fontFamily: "'Rubik', sans-serif",
                  mb: 0.5,
                }}
              >
                {title}
              </Typography>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "#aaa",
                  fontFamily: "'Rubik', sans-serif",
                  lineHeight: 1.5,
                }}
              >
                {description}
              </Typography>
            </Box>

            {/* Arrow */}
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <ArrowForwardIcon sx={{ fontSize: 16, color: "#ccc" }} />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
